import { all, call, put, select, takeLatest } from "redux-saga/effects";
import { http } from "../../common/lib";
import config from "../../config";
import { actionCreators, actionTypes } from "./actions";
import { logToSentry } from "../../config/Sentry";

function* deletePost(action) {
    const { userIds } = action.payload;
    const { userOrganisations } = yield select((state) => state);
    const url = config.api.paths.userLocationsDelete;
    try {
        const { data } = yield call(
            http.authorized.post,
            url,
            userIds.map((user) => ({
                organisation: userOrganisations.item.id,
                user
            }))
        );
        yield put(actionCreators.deletePostSuccess(data));
    } catch (error) {
        console.error(error);
        logToSentry("On user locations delete post:", { error });
        yield put(actionCreators.deletePostFailure(error));
    }
}

function* get() {
    try {
        const { id } = yield select((state) => state.userOrganisations.item);
        const url = `${config.api.paths.userLocations}?organisation=${id}`;
        const { data } = yield call(http.authorized.get, url);
        yield put(actionCreators.getSuccess(data));
    } catch (error) {
        console.error(error);
        logToSentry("On user locations get:", { error });
        yield put(actionCreators.getFailure(error));
    }
}

function* post(action) {
    const { userLocations } = action.payload;
    const { userOrganisations } = yield select((state) => state);
    const url = config.api.paths.userLocations;
    try {
        const { data } = yield call(
            http.authorized.post,
            url,
            userLocations.map((item) => ({
                ...item,
                organisation: userOrganisations.item.id
            }))
        );
        yield put(actionCreators.postSuccess(data));
    } catch (error) {
        console.error(error);
        logToSentry("On user locations post:", { error });
        yield put(actionCreators.postFailure(error));
    }
}

export default function* () {
    yield all([
        takeLatest(actionTypes.USER_LOCATIONS_DELETE_POST_REQUEST, deletePost),
        takeLatest(actionTypes.USER_LOCATIONS_GET_REQUEST, get),
        takeLatest(actionTypes.USER_LOCATIONS_POST_REQUEST, post)
    ]);
}
